import { customization } from "storage";
import { CartItem } from "./CartItem";
import { APP_URL } from "js/common/AppUrl";
import { storage } from "storage";

export class CartItemSurface extends CartItem {
    constructor(e, b) {
        super(e, b);

        this.btnLess = this.element.querySelector(".btn-less");
        this.btnMore = this.element.querySelector(".btn-more");
    }

    attach() {
        super.attach();

        this.btnLess.addEventListener("click", this.onLess);
        this.btnMore.addEventListener("click", this.onMore);
        this.quantityInput.addEventListener("change", this.onInputChange);
        // this.cPopin.on("input", this.onPopinChange);
    }

    detach() {
        super.detach();

        this.btnLess.removeEventListener("click", this.onLess);
        this.btnMore.removeEventListener("click", this.onMore);
        this.quantityInput.removeEventListener("change", this.onInputChange);
        // this.cPopin.off("input", this.onPopinChange);
    }

    onPopinChange = (popin, value) => {
        customization.set(this.element.dataset.code, value);
        // this.cPopin.value = value;
        this.quantityInput.value = value;
        customization.remoteSave();
    };

    onInputChange = () => {
        customization.set(this.element.dataset.code, this.quantityInput.value);
        // this.cPopin.value = this.quantityInput.value;

        customization.remoteSave();
    };

    onLess = () => {
        this.quantityInput.value = Math.max(
            0,
            parseInt(this.quantityInput.value) - 1
        );
        this.onInputChange();
    };

    onMore = () => {
        this.quantityInput.value = parseInt(this.quantityInput.value) + 1;
        this.onInputChange();
    };

    static template(data) {
        const { product, quantity } = data;

        //Get product from storage so we have all data
        const completeProduct = storage.products.get(product.code);
        const entity = completeProduct.entity;
        const entityType = entity.entity_type;

        return `<div data-code="${
            completeProduct.code
        }" data-component="CartItemSurface" class="product-card">
            <li>
                <div class="wrapper-product">
                    <div class="image-container">
                        <img src="${
                            entity.image
                                ? APP_URL +
                                  "/storage/images/91x64-" +
                                  entity.image.filename
                                : ""
                        }" width="91" height="64" class="hide-onmobile"/>
                    </div>
                    <div class="product">
                        ${
                            entity.name
                                ? `<div class="title">${entityType.name} ${entity.name}</div>`
                                : ""
                        }
                        ${
                            entity.legend
                                ? `<div class="legend">${entity.legend}</div>`
                                : ""
                        }
                        ${
                            entity.brand && entity.brand.name
                                ? `<div class="brand">Marque ${entity.brand.name}</div>`
                                : ""
                        }
                        ${
                            completeProduct.reference_inintelligente
                                ? `<div class="ref">Ref. ${completeProduct.reference_inintelligente}</div>`
                                : ""
                        }
                    </div>
                </div>
                <div class="quantity wrapper-quantity">
                    <div class="icon remove remove-mobile"></div>
                    <div class="input-wrapper">
                        <button class="btn-less"><i class="icon less"></i></button>
                        <div class="quantity-container">
                            <input type="number" min="0" max="999" value="${quantity}" />
                            <span>m2</span>
                        </div>
                        <button class="btn-more"><i class="icon plus"></i></button>
                    </div>
                </div>
            </li>
        </div>`;
    }
}
